import { paymentUrl, paymentTestUrl, paymentAcceptUrl, netsPaymentUrl } from '../resources.js'
import postRequest from '../commons/postRequest';
import putRequest from '../commons/putRequest';

async function getPaymentSession(paymentInfo) {
    try {
        return await postRequest.postData(paymentUrl, paymentInfo);
    }
    catch (err) {
        throw err;
    }
}

async function getNetsPaymentSession(paymentInfo) {

    let url = `${netsPaymentUrl}/CreatePaymentSession`; 
    try {
        return await postRequest.postData(url, paymentInfo);
    }
    catch (err) {
        throw err;
    }
}

async function updateNetsPaymentSession(paymentId, paymentInfo) {
    let url = `${netsPaymentUrl}/UpdatePaymentSession/${paymentId}`; 
    try {
        return await putRequest.putData(url, paymentInfo);
    }
    catch (err) {
        throw err;
    }
}

async function getPaymentSessionTest(paymentInfo) {
    try {
        return await postRequest.postData(paymentTestUrl, paymentInfo);
    }
    catch (err) {
        throw err;
    }
}


async function handleCheckoutAccept(paymentInfo) {
    try {
        return await postRequest.postData(paymentAcceptUrl, paymentInfo);
    }
    catch (err) {
        throw err;
    }
}



function handleCheckoutCancel() {

}



export default {
    getPaymentSession,
    getPaymentSessionTest,
    getNetsPaymentSession,
    updateNetsPaymentSession,
    handleCheckoutAccept,
    handleCheckoutCancel
}